import React from 'react';
import { PreferenceLevel } from './types';

const LEVELS: { level: PreferenceLevel; label: string }[] = [
  { level: 'yes', label: 'Yes' },
  { level: 'maybe', label: 'Maybe' },
  { level: 'no', label: 'No' },
];

interface Props {
  value?: PreferenceLevel;
  disabled?: boolean;
  /** Re-selecting the active level passes `undefined` to clear the answer. */
  onChange: (level: PreferenceLevel | undefined) => void;
}

/**
 * The three-tier Yes/Maybe/No button group. Shared by the row-style
 * PreferenceSelector and the per-segment SegmentMatrixSelector so the
 * stoplight buttons and clear-on-toggle behavior live in one place.
 */
const PreferenceButtons: React.FC<Props> = ({ value, disabled, onChange }) => (
  <div className="buyer-profile-preference-buttons">
    {LEVELS.map(({ level, label }) => {
      const active = value === level;
      return (
        <button
          type="button"
          key={level}
          disabled={disabled}
          className={
            `buyer-profile-pref-btn buyer-profile-pref-btn--${level}` +
            (active ? ' buyer-profile-pref-btn--active' : '')
          }
          aria-pressed={active}
          onClick={() => onChange(active ? undefined : level)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default PreferenceButtons;
